import { Card, Col, Row } from "react-bootstrap";
import { Title } from "@/components/lib/Title";
import { ButtonLinkBack } from "@/components/lib/ButtonLinkBack";
import { MyAccountEditForm } from "@/components/entities/user/MyAccountEditForm";

export const MyAccountEdit = () => {
  /* Render
   *******************************************************************************************/
  return (
    <>
      <Row>
        <Col>
          <Title name={"Mon profil"} />
        </Col>
        <Col>
          <ButtonLinkBack />
        </Col>
      </Row>
      <Row className="mt-4">
        <Col className="col-xl-6 col-lg-10 col-md-12 mx-auto">
          <Card className="mb-4">
            <Card.Header>
              <h5 className="mt-2">Modifier mes informations</h5>
            </Card.Header>
            <Card.Body className="p-5">
              <MyAccountEditForm />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};
